import { createEffect, createEvent, createStore, sample } from 'effector';

export type Toast = { id: number; text: string };

let nextId = 1;

export const toastSent = createEvent<string>();
export const toastDismissed = createEvent<number>();

export const $toasts = createStore<Toast[]>([])
  .on(toastSent, (s, text) => [...s, { id: nextId++, text }])
  .on(toastDismissed, (s, id) => s.filter((t) => t.id !== id));

const dismissAfterFx = createEffect<number, void>(
  (id) =>
    new Promise((resolve) => {
      setTimeout(() => {
        toastDismissed(id);
        resolve();
      }, 2400);
    }),
);

sample({
  clock: toastSent,
  source: $toasts,
  fn: (toasts) => toasts[toasts.length - 1]?.id ?? 0,
  target: dismissAfterFx,
});
